// Periodos de tarifas de un producto (specs/009-periodo-tarifas-producto, research.md D4).
// Funciones puras: agrupan, ordenan y eligen el periodo por defecto; la fecha de hoy se inyecta.

export const SIN_PERIODO = 'Sin periodo';

const pad = (n) => String(n).padStart(2, '0');

// Día en formato yyyy-MM-dd a partir de una fecha ISO del backend o de un Date (hora local).
const dia = (valor) => {
  if (!valor) return null;
  if (valor instanceof Date) return `${valor.getFullYear()}-${pad(valor.getMonth() + 1)}-${pad(valor.getDate())}`;
  const texto = String(valor).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(texto) ? texto : null;
};

const nombreDe = (valor) => String(valor ?? '').trim();

const crearPeriodo = (nombre, inicio, fin) => ({
  nombre,
  etiqueta: nombre === '' ? SIN_PERIODO : nombre,
  inicio,
  fin,
});

const menor = (a, b) => (a === null ? b : b === null ? a : a < b ? a : b);
const mayor = (a, b) => (a === null ? b : b === null ? a : a > b ? a : b);

// Del más reciente al más antiguo: por inicio descendente; sin fechas, por nombre descendente;
// "Sin periodo" siempre al final.
export function ordenarPeriodos(periodos) {
  return [...(periodos || [])].sort((a, b) => {
    if (a.nombre === '' && b.nombre !== '') return 1;
    if (b.nombre === '' && a.nombre !== '') return -1;
    if (a.inicio && b.inicio && a.inicio !== b.inicio) return a.inicio < b.inicio ? 1 : -1;
    return b.nombre.localeCompare(a.nombre);
  });
}

// Usa los periodos que entrega el backend; si faltan (backend sin el campo) deriva los de las tarifas.
export function normalizarPeriodos(periodosBackend, tarifas) {
  const fuente = Array.isArray(periodosBackend) && periodosBackend.length > 0
    ? periodosBackend.map((x) => ({ periodo: x.periodo, fechaInicio: x.fechaInicio, fechaFin: x.fechaFin }))
    : (tarifas || []).map((t) => ({ periodo: t.periodo, fechaInicio: t.fechaInicio, fechaFin: t.fechaFin }));

  const porNombre = new Map();
  fuente.forEach((x) => {
    const nombre = nombreDe(x.periodo);
    const inicio = dia(x.fechaInicio);
    const fin = dia(x.fechaFin);
    const actual = porNombre.get(nombre);
    porNombre.set(
      nombre,
      actual
        ? crearPeriodo(nombre, menor(actual.inicio, inicio), mayor(actual.fin, fin))
        : crearPeriodo(nombre, inicio, fin),
    );
  });
  return ordenarPeriodos([...porNombre.values()]);
}

// hoy: Date o 'yyyy-MM-dd'. Sin ambas fechas no se puede afirmar que el periodo esté vigente.
export function estaVigente(periodo, hoy) {
  const d = dia(hoy);
  if (!periodo || !periodo.inicio || !periodo.fin || !d) return false;
  return periodo.inicio <= d && d <= periodo.fin;
}

// El vigente hoy (con varios, el de inicio más reciente); si ninguno lo es, el más reciente.
export function periodoPorDefecto(periodos, hoy) {
  const lista = ordenarPeriodos(periodos);
  if (lista.length === 0) return null;
  return lista.find((p) => estaVigente(p, hoy)) || lista[0];
}

// Fecha (yyyy-MM-dd) con la que se pide al backend las tarifas de un periodo: su inicio.
export function fechaConsulta(periodo) {
  return (periodo && periodo.inicio) || null;
}

// Defensa ante traslapes: solo las tarifas del periodo indicado ('' = sin periodo).
export function filtrarPorPeriodo(tarifas, nombre) {
  if (nombre === null || nombre === undefined) return [];
  const buscado = nombreDe(nombre);
  return (tarifas || []).filter((t) => nombreDe(t.periodo) === buscado);
}
